import { Paper, styled } from "@mui/material";
import { IStyledPaperProps } from "./types";

const StyledPaper = styled(Paper)<IStyledPaperProps>(({theme})=>({
    backgroundColor: (theme as any).palette.background.paper,
    backgroundImage: "none", // avoid MUI's default elevation overlay so it stays true black
    border: "1px solid rgba(255, 255, 255, 0.06)",
    borderRadius: (theme as any).shape.border.general.radius[4],
    // base padding
    padding: theme.spacing(2),
    // Reserve extra horizontal space so absolutely-positioned IconButtons
    // (e.g. top-right / bottom-right) don't overlap content.
    // We add ~48px (icon size + margin) to the right padding.
    position: 'relative',
    width: "100%",
    boxSizing: "border-box",
    "& .section__header":{
        "& .MuiSvgIcon-root":{
            color: (theme as any).palette.secondary.light,
        }
    }
}))

export {StyledPaper}